import { styled } from '@mui/material/styles';

export const RealmAssignmentsContainer = styled('div')({
  maxWidth: 1100,
  width: '100%',
  margin: '0 auto',
});

/** Alternating row banding on even children for scanability (theme-aware, matches users/manage). */
export const ZebraList = styled('div')(({ theme }) => ({
  '& > *:nth-child(even)': {
    backgroundColor: theme.palette.action.disabledBackground,
  },
}));

/** Inset (marginLeft) + zebra banding wrapper — combines the former styles.marginLeft + styles.zebraList. */
export const MarginLeftZebraList = styled('div')(({ theme }) => ({
  marginLeft: theme.spacing(3),
  '& > *:nth-child(even)': {
    backgroundColor: theme.palette.action.disabledBackground,
  },
}));

export const RowSpace = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
}));
